import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/purchase-management/purchase-invoices`;

export const purchaseInvoicesRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:purchaseInvoiceId`,
  debtPayment: `${baseRoute}/debt-payment/:purchaseInvoiceId`,
  viewPayment: `${baseRoute}/view-payment/:purchaseInvoiceId`,
  returnGoods: `${baseRoute}/return-goods/:purchaseInvoiceId`,
} as const;

export type IPurchaseInvoicesRouteParams = IExtractRouteParamMap<
  typeof purchaseInvoicesRoutesObj
>;

export const purchaseInvoicesPath = createPaths<
  typeof purchaseInvoicesRoutesObj,
  IPurchaseInvoicesRouteParams
>(purchaseInvoicesRoutesObj);
